import * as React from 'react';
import {FunctionComponent} from 'react';
import {Slide} from '../../components/slide';
import {Heading, List, ListItem} from 'spectacle';
import {Sprint} from '../../model/sprint';
import {isSameWeek} from 'date-fns';

interface OwnProps {
    sprints: Sprint[];
}

export const ProjectsOverview: FunctionComponent<OwnProps> = ({sprints}) => {
    const now = new Date();
    return (
        <Slide major>
            <Heading size={1} style={{textAlign: 'left'}} lineHeight={1} textColor="secondary">
                Projects
            </Heading>
            <List margin="30px 0 0" textFont="secondary" textColor="secondary" bold>
                {sprints
                    .reduce((p: string[], sprint: Sprint) => {
                        if (isSameWeek(now, new Date(sprint.date)) && p.indexOf(sprint.estimate.name) === -1) {
                            return [...p, sprint.estimate.name];
                        }
                        return p;
                    }, [])
                    .map((estimateName) => {
                        return <ListItem key={estimateName}>{estimateName}</ListItem>;
                    })}
            </List>
        </Slide>
    );
};
